import config from '../config';
import fetch from 'cross-fetch';
import store from 'store2';
import {
    loadAllEmailTemplates,
    removeEmailTemplateById,
    errorGettingEmailTemplate,
    loadEmailTemplateById,
    errorGettingEmailTemplateById,
    editEmailTemplate,
    errorEditEmailTemplate,
} from '../actions/emailTemplate';
import { addNotification as notify } from 'reapop';
import { push } from 'react-router-redux';

export function fetchAllEmailTemplates() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/emailTemplate`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
            return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadAllEmailTemplates({list: json}));
          }
        })
        .catch(response => {
          dispatch(errorGettingEmailTemplate({error: response}))
        });
    }
  }
}

export function saveEmailTemplate(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/emailTemplate/`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(push('/pages/emailtemplates'));
            dispatch(notify({
              title: 'Add New Email Template',
              message: 'Email template added successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Add New Email Template',
            message: 'Failed to add new email template',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}

export function deleteEmailTemplateById(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/emailTemplate/${data.id}`, {
          method: 'DELETE',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(removeEmailTemplateById({ id: data.id }));
            dispatch(notify({
              title: 'Delete Email Template Card',
              message: 'Email Tempalte deleted successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
    }
  }
}

export function fetchEmailTemplateById(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/emailTemplate/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
            return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadEmailTemplateById({ emailTemplate: json }));
          }
        })
        .catch(response => {
          dispatch(errorGettingEmailTemplateById({ error: response }))
        });
    }
  }
}

export function updateEmailTemplate(id, data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/emailTemplate/${id}`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(push('/pages/emailtemplates'));
            dispatch(editEmailTemplate(json));
            dispatch(notify({
              title: 'Edit Email Template',
              message: 'Email template edited successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(errorEditEmailTemplate(response));
          dispatch(notify({
            title: 'Edit Email Template',
            message: 'Failed edit email template',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/emailTemplate.js